import { PERMISSIONS } from '@core/constants/permissions.constants';
import { ReportConfig } from './sparepart-report.config';

export const TECHNICIAN_EFFICIENCY_REPORT_CONFIG: ReportConfig = {
  id: 'technician-efficiency',
  title: 'Technician Efficiency Report',
   permissions: {
      view: PERMISSIONS.GSE.REPORTS.TECHNICIAN_EFFICIENCY.VIEW,
      export: PERMISSIONS.GSE.REPORTS.TECHNICIAN_EFFICIENCY.EXPORT,
    },
  filters: [
    {
      type: 'text',
      field: 'search',
      label: 'Search',
      placeholder: 'Search'
    },
    {
      type: 'date-range',
      field: 'dateRange',
      label: 'Date Range',
      placeholder: 'Date range'
    },
    {
      type: 'dropdown',
      field: 'technician',
      label: 'Technician',
      placeholder: 'Technician',
      multiselect: false,
      required: true,
    }
  ],

  columns: [
    {
      field: 'jobCardId',
      header: 'Job Card ID',
      type: 'text',
      width: '12%',
    },
    {
      field: 'jobType',
      header: 'Job Type',
      type: 'text',
      pipes: ['formatStatus', 'replaceUnderscore', 'titlecase'],
      width: '22%',
    },
    {
      field: 'estimatedHours',
      header: 'Estimated Hours',
      type: 'number',
      width: '16%',
    },
    {
      field: 'actualHours',
      header: 'Actual Hours',
      type: 'number',
      width: '16%',
    },
    {
      field: 'efficiencyPercentage',
      header: 'Efficiency (%)',
      type: 'number',
      width: '34%',
    },
  ],
};
